module.exports = __webpack_public_path__ + "img/teach3.cb616c19.jpg";